<app-navbar>
  <div class="container-fluid bg-light p-4">
    <div class="text-center mb-5">
      <h2 class="title-page-regime">Instituições em Regime Especial</h2>
      <p class="small-title-regime">Confira abaixo as instituições em liquidação ou intervenção</p>
    </div>

    <div class="container bg-white shadow-sm rounded-lg p-4 p-md-5">

      <div class="results-count mb-4">
        <p class="text-muted">{{ tableDataCard.length }} instituições encontradas</p>
      </div>

      <div class="row justify-content-start">
        <div *ngFor="let card of tableDataCard"
            class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4 d-flex justify-content-center">

          <div class="card card-regime-especial">
            <div class="card-body">

              <div class="icon-container mb-4">
                <span class="material-icons-outlined">account_balance</span>
              </div>

              <h3 class="card-title">{{card.nomeInstituicaoFinanceira}}</h3>

              <div class="mt-auto w-100">
                <span class="badge-liquidacao">
                  Liquidação: {{card.dataLiquidacao | date: 'dd/MM/yyyy'}}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div *ngIf="tableDataCard.length === 0" class="text-center my-5">
        <p class="text-muted">Nenhuma instituição financeira encontrada.</p>
      </div>

      <div class="footer-actions d-flex justify-content-center mt-5">
        <button routerLink="/home" class="btn-voltar">
          <i class="fas fa-arrow-left me-2"></i> Voltar ao Portal Investidor
        </button>
      </div>

    </div>
  </div>
</app-navbar>
<app-footer></app-footer>

